/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { Global, css } from '@emotion/react';
import { title, header, commentText } from './fonts';
import { useColorMode } from './ColorMode';

// eslint-disable-next-line
export const GlobalStyle = (props) => {
  const [, , getColor] = useColorMode();
  return (
    <Global
      styles={css`
        * {
          box-sizing: border-box;
          border-width: 0px;
        }

        .grecaptcha-badge {
          visibility: hidden;
        }

        html {
          font-size: 100%;
          display: flex;
        }
        body {
        }

        html,
        body {
          width: 100%;
          margin: 0;
          padding: 0;
          background: ${getColor('white')};
          font-family: HelveticaNeue, Helvetica Neue, sans-serif;
          position: relative;
          line-height: 1.5;
          flex: 1;
          font-smooth: auto;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        .markdown-body h1 {
          ${header}
        }
        .markdown-body h2 {
          ${title}
        }
        .markdown-body,
        .markdown-body p,
        .markdown-body li {
          ${commentText}
        }

        #app,
        main {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-height: 100%;
          position: relative;
          width: 100%;
        }

        a {
          color: ${getColor('blue')};
          overflow-wrap: anywhere;
          text-decoration: none;
          cursor: pointer;
        }

        .react-toast-notifications__container {
          z-index: 11000 !important;
          top: 64px !important;
        }

        .smartbanner-top.smartbanner-android {
          z-index: 900 !important;
          top: -80px !important;
        }
        .smartbanner-top.smartbanner-ios {
          z-index: 900 !important;
          top: -80px !important;
        }

        // Hamburger menu transition time
        .bm-overlay,
        .bm-menu-wrap {
          top: 0;
          transition-duration: 0.3s !important;
        }

        @media screen and (max-device-width: 746px) {
          .BeaconContainer {
            /*bottom: 30px !important; */
            left: 0 !important;
            top: 0 !important;
            padding-bottom: 32px;
          }
          .c-BeaconCloseButton {
            padding: 0;
            margin: 0;
            top: auto !important;
            bottom: -32px !important;
            height: 32px;
            backgroundcolor: blue;
            z-index: 1000 !important;
          }
          .BeaconFabButtonFrame {
            left: 16px !important;
            right: auto !important;
            bottom: 16px !important;
            z-index: 900 !important;
          }
        }
      `}
    />
  );
};
